import Hotkeys from 'react-hot-keys';
import { SlideFromRightWrapper } from '../../components/common/SlideFromRightWrapper';
import { PureComponent, ReactNode } from 'react';
import { AP } from '../NewQueue';
import TreatmentPlanRightPanel from '../../components/prescriptionPad/rightPanel/workspace/TreatmentPlan/TreatmentPlanRightPanel';
import { Doctor } from '../../store/types/prescription';
import { getDoctorProfile } from '../../store/idbHandler';

interface Props {
    appointment: AP;
    closeMe: () => void;
}

type State = {
    doctor?: Doctor;
};

class ApptTreatmentPlanRightPopUp extends PureComponent<Props, State> {
    async componentDidMount(): Promise<void> {
        const { appointment } = this.props;
        const doctor = await getDoctorProfile(appointment.doctor_oid);
        if (doctor) {
            this.setState({ doctor });
        }
    }

    render(): ReactNode {
        const { closeMe, appointment } = this.props;
        const { doctor } = this.state;

        if (!doctor) {
            return null;
        }

        return (
            <Hotkeys keyName="esc">
                <SlideFromRightWrapper
                    closeMe={closeMe}
                    style={{ width: '90%', maxWidth: '1200px' }}
                >
                    <TreatmentPlanRightPanel
                        appointment={appointment}
                        closeMe={closeMe}
                        docProfile={doctor}
                    />
                </SlideFromRightWrapper>
            </Hotkeys>
        );
    }
}

export default ApptTreatmentPlanRightPopUp;
